/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.custom.enrichment.rpc.client.SmartPropertiesBulkService
 */

export const enqueueBulkRequestRpc = {
  serviceName: 'com.hubspot.custom.enrichment.rpc.client.SmartPropertiesBulkService',
  rpcName: 'enqueueBulkRequest',
  auth: 'app',
  fingerprint: 'YpAOQeWeuWbt4cnDmTGntl053aHnqd6P',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const enqueueListBulkRequestRpc = {
  serviceName: 'com.hubspot.custom.enrichment.rpc.client.SmartPropertiesBulkService',
  rpcName: 'enqueueListBulkRequest',
  auth: 'app',
  fingerprint: 'ALSMYny2IX7t4cnDmTGntl053aHnqd6P',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};